module.exports = __webpack_public_path__ + "img/face-laugh-beam.054ab6df.svg";